export default __webpack_public_path__ + "23bba99f8cd3f4e3cbb817b91741c77d.png";